<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container"
      @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!topNav" />
    <top-nav id="topmenu-container" class="topmenu-container" v-if="topNav" />

    <div class="rightArea">
      <div class="title-text">
        <span class="t1" v-if="show">
          {{ $store.state.user.accountBalanceInfo.zh }}
          <span style="margin: 0 10px;"></span>
          账号余额:{{
            $store.state.user.accountBalanceInfo.money }}元
        </span>
        {{ company_name }}
      </div>
      <div class="right-menu">
        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <img :src="avatar" class="user-avatar" />
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/index">
              <el-dropdown-item>个人中心</el-dropdown-item>
            </router-link>
            <el-dropdown-item @click.native="setting = true" v-if="false">
              <span>布局设置</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import TopNav from "@/components/TopNav";
import Hamburger from "@/components/Hamburger";
import { getUserInfo, getAuthInfo } from "@/utils/auth";
export default {
  components: {
    Breadcrumb,
    TopNav,
    Hamburger
  },
  data() {
    return {
      avatar: "",
      show: false,
      company_name: ""
    };
  },
  computed: {
    ...mapGetters(["sidebar", "device"]),
    setting: {
      get() {
        return this.$store.state.settings.showSettings;
      },
      set(val) {
        this.$store.dispatch("settings/changeSetting", {
          key: "showSettings",
          value: val
        });
      }
    },
    topNav: {
      get() {
        return this.$store.state.settings.topNav;
      }
    }
  },
  watch: {
    $route: {
      handler(newV, oldV) {
        // if (newV.path == "/moneyManagement/payManagement") {
        if (["/moneyManagement/payManagement", "/moneyManagement/finaceChange", "/moneyManagement/moneyRecord"].includes(newV.path)) {
          this.show = true;
          this.$store.dispatch("user/setAccountBalance");
        } else {
          this.show = false;
        }
      },
      immediate: true
    }
  },
  mounted() {
    let userInfo = getUserInfo();
    let authInfo = getAuthInfo();
    this.avatar = userInfo.head_pic || "http://img.zhgylgl.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20240527153732.png";
    this.company_name = authInfo.company_name;
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$store.dispatch("user/LogOut")
        })
        .catch(() => { });
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 10px 10px -10px rgba(0, 21, 41, 0.5);
  border-bottom: 1px solid #f1f1f1;

  .rightArea {
    display: flex;
    height: 100%;
    justify-content: space-between;
  }

  .title-text {
    width: 93%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    padding-left: 30px;
    font-size: 18px;
    min-width: 200px;
    overflow: hidden;
    white-space: nowrap;

    .t1 {
      color: rgb(255, 0, 0);
      font-size: 14px;
      margin: 0 10px;
    }
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
    min-width: 100px;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    // float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
